import { motion } from "framer-motion";

/**
 * EditorialNumber — a giant italic serif number ghosted on the section background.
 * Inspired by editorial magazine layouts (Vogue, AD).
 *
 * Props:
 *  - n: string (e.g., "01", "02")
 *  - variant: "light" | "dark" — controls tint against light or dark section bg
 *  - align: "right" | "left" — anchoring side
 */
export const EditorialNumber = ({ n, variant = "dark", align = "right" }) => {
  const color =
    variant === "light"
      ? "rgba(241,238,232,0.055)"
      : "rgba(15,14,12,0.055)";
  return (
    <div
      className={`absolute inset-0 pointer-events-none flex items-center overflow-hidden ${
        align === "right" ? "justify-end" : "justify-start"
      }`}
      aria-hidden="true"
    >
      <motion.span
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-120px" }}
        transition={{ duration: 1.4, ease: [0.7, 0, 0.2, 1] }}
        className="italic-serif select-none leading-none"
        style={{
          color,
          fontSize: "clamp(18rem, 48vw, 62rem)",
          transform: align === "right" ? "translateX(14%) translateY(-4%)" : "translateX(-14%) translateY(-4%)",
          letterSpacing: "-0.05em",
          fontFamily: "'Playfair Display', Georgia, serif",
          fontWeight: 500,
        }}
      >
        {n}
      </motion.span>
    </div>
  );
};
